import React, { ReactNode } from 'react'
import { RouteProps } from 'react-router-dom'
import User from 'remixicon-react/UserLineIcon'
import Building from 'remixicon-react/Building4LineIcon'
import Settings2FillIcon from 'remixicon-react/Settings2FillIcon'
import { Organizations } from './Organizations'
import { Profile } from '~/Views/Main/Profile'

import { Info } from '~/Views/Main/Organizations/Info'
import { Users } from '~/Views/Main/Organizations/Users'
import { Licenses } from '~/Views/Main/Organizations/Licenses'
import { Roles } from '~/Views/Main/Organizations/Roles'
import { AuditLog } from '~/Views/Main/Organizations/AuditLog'
import { Devices } from './Admin/Devices/Devices'
import { Admin } from './Admin'
import { AdminLicenses } from './Admin/Licenses'
import { AdminProducts } from './Admin/Products'
import { AdminOrganizations } from './Admin/Organizations'
import { AdminClaims } from './Admin/Claims'
import { AdminRoles } from './Admin/Roles'
import { AdminUsers } from './Admin/Users'

export const enum RootClaim {
  System = 'System',
  Admin = 'Admin',
  User = 'User',
}

export const enum OrgClaim {
  Member = 'Member',
  Admin = 'Admin',
  Superuser = 'SuperUser',
}

interface RouteObj {
  label: string
  icon?: ReactNode
  rootPermission: RootClaim[]
  orgPermission: OrgClaim[]
  routeProps: RouteProps
  documentTitle?: string
}

export const Routes: RouteObj[] = [
  {
    label: 'sidebar.organizations',
    rootPermission: [RootClaim.System, RootClaim.Admin],
    icon: <Building />,
    orgPermission: [OrgClaim.Member, OrgClaim.Superuser, OrgClaim.Admin],
    routeProps: {
      path: '/Organizations',
      children: <Organizations />,
    },
    documentTitle: 'header.organizations',
  },
  {
    label: 'sidebar.myProfile',
    rootPermission: [RootClaim.System, RootClaim.Admin, RootClaim.User],
    orgPermission: [],
    icon: <User />,
    routeProps: {
      path: '/Profile',
      children: <Profile />,
    },
    documentTitle: 'header.myProfile',
  },
  {
    label: 'sidebar.systemAdmin',
    rootPermission: [RootClaim.System],
    orgPermission: [],
    icon: <Settings2FillIcon />,
    routeProps: {
      path: '/Admin',
      children: <Admin />,
    },
    documentTitle: 'header.systemAdmin',
  },
]

export const OrgRoutes: RouteObj[] = [
  {
    label: 'sidebar.info',
    rootPermission: [RootClaim.System, RootClaim.Admin],
    orgPermission: [OrgClaim.Member, OrgClaim.Superuser, OrgClaim.Admin],
    routeProps: {
      path: '',
      children: <Info />,
    },
    documentTitle: 'header.organizationInfo',
  },
  {
    label: 'sidebar.users',
    rootPermission: [RootClaim.System, RootClaim.Admin],
    orgPermission: [OrgClaim.Member, OrgClaim.Superuser, OrgClaim.Admin],
    routeProps: {
      path: '/Users',
      children: <Users />,
    },
    documentTitle: 'header.organizationUsers',
  },
  {
    label: 'sidebar.licenses',
    rootPermission: [RootClaim.System, RootClaim.Admin],
    orgPermission: [OrgClaim.Superuser, OrgClaim.Admin],
    routeProps: {
      path: '/Licenses',
      children: <Licenses />,
    },
    documentTitle: 'header.licenses',
  },
  {
    label: 'sidebar.roles',
    rootPermission: [RootClaim.System, RootClaim.Admin],
    orgPermission: [OrgClaim.Superuser, OrgClaim.Admin],
    routeProps: {
      path: '/Roles',
      children: <Roles />,
    },
    documentTitle: 'header.roles',
  },
  {
    label: 'sidebar.auditLog',
    rootPermission: [RootClaim.System, RootClaim.Admin],
    orgPermission: [OrgClaim.Superuser, OrgClaim.Admin],
    routeProps: {
      path: '/AuditLog',
      children: <AuditLog />,
    },
    documentTitle: 'header.auditLog',
  },
]

export const SystemRoutes: RouteObj[] = [
  {
    label: 'sidebar.organizations',
    rootPermission: [RootClaim.System],
    orgPermission: [],
    routeProps: {
      path: '',
      children: <AdminOrganizations />,
    },
    documentTitle: 'header.systemAdmin',
  },
  {
    label: 'sidebar.users',
    rootPermission: [RootClaim.System, RootClaim.Admin],
    orgPermission: [OrgClaim.Member, OrgClaim.Superuser, OrgClaim.Admin],
    routeProps: {
      path: '/AdminUsers',
      children: <AdminUsers />,
    },
    documentTitle: 'header.systemAdmin',
  },
  {
    label: 'sidebar.licenseTypes',
    rootPermission: [RootClaim.System],
    orgPermission: [],
    routeProps: {
      path: '/LicenseTypes',
      children: <AdminLicenses />,
    },
    documentTitle: 'header.systemAdmin',
  },
  {
    label: 'sidebar.claims',
    rootPermission: [RootClaim.System, RootClaim.Admin],
    orgPermission: [],
    routeProps: {
      path: '/Claims',
      children: <AdminClaims />,
    },
    documentTitle: 'header.systemAdmin',
  },
  {
    label: 'sidebar.products',
    rootPermission: [RootClaim.System],
    orgPermission: [],
    routeProps: {
      path: '/Products',
      children: <AdminProducts />,
    },
    documentTitle: 'header.systemAdmin',
  },
  {
    label: 'sidebar.devices',
    rootPermission: [RootClaim.System],
    orgPermission: [],
    routeProps: {
      path: '/Devices',
      children: <Devices />,
    },
    documentTitle: 'header.systemAdmin',
  },
]